import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import FileSaver from 'file-saver';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import GdsRcpt0201Actions, { GdsRcpt0201Types } from '../Stores/GdsRcpt0201/Actions';

const getAppStore = state => state.app;

export function* gdsRcpt0201FetchGdsRcpt0201({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(GdsRcpt0201Actions.gdsRcpt0201FetchGdsRcpt0201Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `gdsRcpt/indexProcess/GDS_RCPT_02_01/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        GdsRcpt0201Actions.gdsRcpt0201FetchGdsRcpt0201Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(GdsRcpt0201Actions.gdsRcpt0201FetchGdsRcpt0201Loading(false));
  }
}

export function* gdsRcpt0201PrintGdsRcpt0201({ hdrIds }) {
  try {
    yield put(GdsRcpt0201Actions.gdsRcpt0201PrintGdsRcpt0201Loading(true));

    const app = yield select(getAppStore);

    const getData = {
      hdrIds
    };

    const result = yield call(
      ApiService.downloadGetApi, // function
      app.apiUrl,
      `gdsRcpt/printProcess/GDS_RCPT_02/${app.curSiteFlowId}`,
      app.token,
      getData,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    );

    if (result.isSuccess === true) {
      const selectedDocuments = hdrIds.map(d => ({ id: d }));

      FileSaver.saveAs(result.data, 'WhseJob.pdf');
      yield put(GdsRcpt0201Actions.gdsRcpt0201RemoveSelectedDocuments(selectedDocuments));
      yield put(GdsRcpt0201Actions.gdsRcpt0201ResetTimestamp());
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(GdsRcpt0201Actions.gdsRcpt0201PrintGdsRcpt0201Loading(false));
  }
}

export function* gdsRcpt0201GoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/gdsRcptDetail/update/${hdrId}`));
}

export const saga = [
  takeLatest(GdsRcpt0201Types.GDS_RCPT0201_GO_TO_DOCUMENT, gdsRcpt0201GoToDocument),
  takeLatest(GdsRcpt0201Types.GDS_RCPT0201_FETCH_GDS_RCPT0201, gdsRcpt0201FetchGdsRcpt0201),
  takeLatest(GdsRcpt0201Types.GDS_RCPT0201_PRINT_GDS_RCPT0201, gdsRcpt0201PrintGdsRcpt0201)
];
